export default {"src":"/_next/static/media/dark-linkedin-icon.ba16edaa.svg","height":26,"width":26};